import { required, decimal } from 'vuelidate/lib/validators';

// Same rules as ./addVariation (used by the article Edit screen), minus vpc
// which has no input on the create-article variation modal.
const validations = {
  code: {
    required,
  },
  mpc: {
    required,
    decimal,
  },
  salePrice: {
    decimal,
  },
};

export default validations;
